//统计报表

export default [

    {   //妥投未入库报表
        path: "report/votenoinbound",
        name: "reportVotenoinbound",
        component: () => import(/* webpackChunkName: "report" */ "@/views/report/votenoinbound/index")
    },
    {   //超时未上架监控报表
        path: "report/onshelf",
        name: "reportOnshelf",
        component: () => import(/* webpackChunkName: "report" */ "@/views/report/onshelf/index")
    },
    {   //仓库KPI报表
        path: "report/storagekpi",
        name: "reportOnshelf",
        component: () => import(/* webpackChunkName: "report" */ "@/views/report/storagekpi/index")
    },
    {   //仓库KPI报表配置
        path: "report/storagekpisetting",
        name: "reportOnshelf",
        component: () => import(/* webpackChunkName: "report" */ "@/views/report/storagekpi/setting")
    },
    // 库容预测
    {
        path:'report/capacity',
        name:'reportCapacity',
        component: () => import(/* webpackChunkName: "report" */ "@/views/report/capacity/index")
    },
    {
        path:'report/capacity/:type',
        name:'reportCapacityUpdate',
        component: () => import(/* webpackChunkName: "report" */ "@/views/report/capacity/update")
    },
    // 库容预测看板
    {
        path:'report/capacityreport',
        name:'reportCapacityReport',
        component: () => import(/* webpackChunkName: "report" */ "@/views/report/capacity/capacityreport")
    },
]
